import React from 'react';

const DownArrowIcon = () => {
  return (
    <svg width="15" height="9" viewBox="0 0 15 9" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 5.89L13.39 0 15 1.612 7.764 8.847 7.5 8.583l-.264.264L0 1.61 1.61 0 7.5 5.89z" fill="currentColor" fillRule="evenodd" />
    </svg>
  );
};

export default DownArrowIcon;
